import { render, staticRenderFns } from "./CustomerProfile.vue?vue&type=template&id=4517d762&scoped=true&"
import script from "./CustomerProfile.vue?vue&type=script&lang=js&"
export * from "./CustomerProfile.vue?vue&type=script&lang=js&"
import style0 from "./CustomerProfile.vue?vue&type=style&index=0&id=4517d762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4517d762",
  null
  
)

export default component.exports